import React, { useMemo } from "react";

import { HexColor } from "@mapmycustomers/shared/types/AnyColor";

interface Props {
  className?: string;
  gradient: HexColor[]; // an array of hex colors or any other CSS3 colors
  gradientAngle?: "{number}deg"; // limiting only to deg to simplify types
}

const Gradient: React.FC<Props> = ({ className, gradient, gradientAngle = "90deg" }) => {
  const background = useMemo(() => {
    const step = gradient.length > 1 ? 100 / (gradient.length - 1) : 100;
    const colors = gradient.map((color, index) => `${color} ${step * index}%`).join(",");
    return `linear-gradient(${gradientAngle}, ${colors})`;
  }, [gradient, gradientAngle]);

  return <div className={className} style={{ background }} />;
};

export default Gradient;
